import React from "react";
import { compose, graphql } from "react-apollo";
import { withQuery } from "containers/withQuery";

import translateErrorMessage from "utils/translateErrorMessage";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import PlantLocationModal from "./PlantLocationModal";
import { PLANT_LOCATION_QUERY, PLANT_LOCATIONS_QUERY } from "../generalRegisterQueries";
import { UPDATE_PLANT_LOCATION_MUTATION } from "../generalRegisterMutations";

const PlantLocationEdit = ({
  plantLocation,
  updatePlantLocation,
  id,
  snackbarContext,
  onFinishEdit,
}) => {
  const onSave = (newPlantLocation) => {
    updatePlantLocation({
      variables: {
        id,
        params: newPlantLocation
      },
      refetchQueries: [{
        query: PLANT_LOCATIONS_QUERY
      }]
    })
      .then(() => {
        snackbarContext.setNotificationTimeOut(Color.success, "Card atualizado.");
        onFinishEdit();
      })
      .catch(error => {
        snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  };

  return (
    <PlantLocationModal
      toggleModal={onFinishEdit}
      isOpen={id}
      onSave={onSave}
      {...plantLocation}
      title="Editar card"
    />
  );
};

export default compose(
  withQuery(({ id }) => ({
    query: PLANT_LOCATION_QUERY,
    variables: {
      id,
    },
    noLoader: true,
  })),
  graphql(UPDATE_PLANT_LOCATION_MUTATION, { name: "updatePlantLocation", }),
  withSnackbarConsumer,
)(PlantLocationEdit);
